import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useAuth, useMainTradeData } from "@saleor/sdk";
import { GOOGLE_RECAPTCHA_KEY, signInType } from "@temp/constants";
import principleLogo from "@temp/images/logo-ep-ai-red.svg";
import React from "react";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import { useNavigate, useParams } from "react-router-dom";
import { ChangeAmountProductsContext } from "@temp/contexts";
import { logInMessages } from "@temp/intl";
import { useIntl } from "react-intl";
import { AlertAnonymousChoice, LayoutLoginManager } from "@temp/components";
import * as paths from "../../../app/routes/paths";
import { EcommerceLoginLoading } from "./EcommerceLoginLoading";
export var EcommerceLogin = function EcommerceLogin() {
  var _dataMainTrade$mainTr4, _dataMainTrade$mainTr5, _dataMainTrade$mainTr6, _dataMainTrade$mainTr7, _dataMainTrade$mainTr8, _dataMainTrade$mainTr9, _dataMainTrade$mainTr10, _dataMainTrade$mainTr11, _dataMainTrade$mainTr12, _dataMainTrade$mainTr13;

  var _useParams = useParams(),
      slug = _useParams.slug;

  var intl = useIntl();

  var _React$useState = React.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      seeCode = _React$useState2[0],
      setSeeCode = _React$useState2[1];

  var _React$useState3 = React.useState(false),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      showValidateCode = _React$useState4[0],
      setShowValidateCode = _React$useState4[1];

  var _React$useState5 = React.useState(true),
      _React$useState6 = _slicedToArray(_React$useState5, 2),
      loading = _React$useState6[0],
      setLoading = _React$useState6[1];

  var _React$useState7 = React.useState(false),
      _React$useState8 = _slicedToArray(_React$useState7, 2),
      resendCode = _React$useState8[0],
      setResendCode = _React$useState8[1];

  var _React$useState9 = React.useState(false),
      _React$useState10 = _slicedToArray(_React$useState9, 2),
      showWrongTrade = _React$useState10[0],
      setShowWrongTrade = _React$useState10[1];

  var _React$useState11 = React.useState(false),
      _React$useState12 = _slicedToArray(_React$useState11, 2),
      showAnonymousChoice = _React$useState12[0],
      setShowAnonymousChoice = _React$useState12[1];

  var _React$useState13 = React.useState([]),
      _React$useState14 = _slicedToArray(_React$useState13, 2),
      errorsValidateCode = _React$useState14[0],
      setErrorsValidateCode = _React$useState14[1];

  var _React$useState15 = React.useState([]),
      _React$useState16 = _slicedToArray(_React$useState15, 2),
      errorsVerifyCustomerAccount = _React$useState16[0],
      setErrorsVerifyCustomerAccount = _React$useState16[1];

  var _React$useState17 = React.useState(""),
      _React$useState18 = _slicedToArray(_React$useState17, 2),
      codeState = _React$useState18[0],
      setCodeState = _React$useState18[1];

  var _React$useState19 = React.useState(""),
      _React$useState20 = _slicedToArray(_React$useState19, 2),
      userWaNumber = _React$useState20[0],
      setUserWaNumber = _React$useState20[1];

  var _React$useState21 = React.useState(slug),
      _React$useState22 = _slicedToArray(_React$useState21, 2),
      slugState = _React$useState22[0],
      setSlugState = _React$useState22[1];

  var _React$useState23 = React.useState("CO"),
      _React$useState24 = _slicedToArray(_React$useState23, 2),
      defaultCountryCode = _React$useState24[0],
      setDefaultCountryCode = _React$useState24[1];

  var _React$useState25 = React.useState({}),
      _React$useState26 = _slicedToArray(_React$useState25, 2),
      userData = _React$useState26[0],
      setUserData = _React$useState26[1];

  var _useAuth = useAuth(),
      user = _useAuth.user,
      verifyCustomerAccount = _useAuth.verifyCustomerAccount,
      validateCustomerCode = _useAuth.validateCustomerCode;

  var navigate = useNavigate();

  var _React$useContext = React.useContext(ChangeAmountProductsContext),
      maxProductsPerCategory = _React$useContext.maxProductsPerCategory;

  var _useMainTradeData = useMainTradeData({
    slug: slugState
  }, {
    fetchPolicy: "network-only"
  }),
      dataMainTrade = _useMainTradeData.data,
      loadingMainTradeData = _useMainTradeData.loading;

  var handleLogIn = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(e, userWaNumber) {
      var _dataMainTrade$mainTr, _verify$data, _verify$data2, _verify$data3, _verify$data4, verify, _verify$data5, _verify$data6, _verify$data7, _verify$data8, _verify$data9, _verify$data9$user, _verify$data10;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              e.preventDefault();

              if (!(userWaNumber !== "" && userWaNumber !== undefined)) {
                _context.next = 10;
                break;
              }

              setLoading(true);
              _context.next = 5;
              return verifyCustomerAccount(+atob(dataMainTrade === null || dataMainTrade === void 0 ? void 0 : (_dataMainTrade$mainTr = dataMainTrade.mainTradeData) === null || _dataMainTrade$mainTr === void 0 ? void 0 : _dataMainTrade$mainTr.id).split(":")[1], userWaNumber);

            case 5:
              verify = _context.sent;

              if ((verify === null || verify === void 0 ? void 0 : (_verify$data = verify.data) === null || _verify$data === void 0 ? void 0 : _verify$data.userWaNumber) && (verify === null || verify === void 0 ? void 0 : (_verify$data2 = verify.data) === null || _verify$data2 === void 0 ? void 0 : _verify$data2.userWaNumber) !== null && (verify === null || verify === void 0 ? void 0 : (_verify$data3 = verify.data) === null || _verify$data3 === void 0 ? void 0 : _verify$data3.userWaNumber) !== undefined && (verify === null || verify === void 0 ? void 0 : (_verify$data4 = verify.data) === null || _verify$data4 === void 0 ? void 0 : _verify$data4.userWaNumber) !== "") {
                setUserData({
                  accessCodeSeconds: verify === null || verify === void 0 ? void 0 : (_verify$data5 = verify.data) === null || _verify$data5 === void 0 ? void 0 : _verify$data5.accessCodeSeconds,
                  siteSettings: verify === null || verify === void 0 ? void 0 : (_verify$data6 = verify.data) === null || _verify$data6 === void 0 ? void 0 : _verify$data6.siteSettings,
                  userWaNumber: verify === null || verify === void 0 ? void 0 : (_verify$data7 = verify.data) === null || _verify$data7 === void 0 ? void 0 : _verify$data7.userWaNumber,
                  userHasAcceptedTyc: !!((verify === null || verify === void 0 ? void 0 : (_verify$data8 = verify.data) === null || _verify$data8 === void 0 ? void 0 : _verify$data8.user) !== null ? verify === null || verify === void 0 ? void 0 : (_verify$data9 = verify.data) === null || _verify$data9 === void 0 ? void 0 : (_verify$data9$user = _verify$data9.user) === null || _verify$data9$user === void 0 ? void 0 : _verify$data9$user.hasAcceptedTyc : verify === null || verify === void 0 ? void 0 : (_verify$data10 = verify.data) === null || _verify$data10 === void 0 ? void 0 : _verify$data10.user)
                });
                setShowValidateCode(true);

                if (errorsVerifyCustomerAccount.length > 0) {
                  setErrorsVerifyCustomerAccount([]);
                }
              } else if ((verify === null || verify === void 0 ? void 0 : verify.dataError.error.length) > 0) {
                setErrorsVerifyCustomerAccount(verify === null || verify === void 0 ? void 0 : verify.dataError.error);
              }

              setLoading(false);
              _context.next = 11;
              break;

            case 10:
              setErrorsVerifyCustomerAccount([{
                code: "WA_NUMBER_REQUIRED",
                field: "userWaNumber",
                message: "El número de WhatsApp es requerido"
              }]);

            case 11:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function handleLogIn(_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();

  var handleChange = React.useCallback(function () {
    if (errorsVerifyCustomerAccount.length > 0) {
      setErrorsVerifyCustomerAccount([]);
    }

    setCodeState("");
    setShowValidateCode(false);
    setUserWaNumber("");
  }, [setShowValidateCode, setUserWaNumber]);

  var handleValidateCode = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(e, code, userHasAcceptedTyc) {
      var _validate$dataError, _validate$dataError$e, _validate$data, validate, _validate$dataError2;

      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              e.preventDefault();

              if (!(code !== "" && code !== undefined)) {
                _context2.next = 15;
                break;
              }

              setLoading(true);
              _context2.next = 5;
              return validateCustomerCode(userData === null || userData === void 0 ? void 0 : userData.userWaNumber, code, maxProductsPerCategory + 1, signInType.normal, userHasAcceptedTyc);

            case 5:
              validate = _context2.sent;

              if (!((validate === null || validate === void 0 ? void 0 : (_validate$dataError = validate.dataError) === null || _validate$dataError === void 0 ? void 0 : (_validate$dataError$e = _validate$dataError.error) === null || _validate$dataError$e === void 0 ? void 0 : _validate$dataError$e.length) > 0)) {
                _context2.next = 10;
                break;
              }

              setErrorsValidateCode(validate === null || validate === void 0 ? void 0 : (_validate$dataError2 = validate.dataError) === null || _validate$dataError2 === void 0 ? void 0 : _validate$dataError2.error);
              setLoading(false);
              return _context2.abrupt("return");

            case 10:
              if (errorsValidateCode.length > 0) {
                setErrorsValidateCode([]);
              }

              if (validate === null || validate === void 0 ? void 0 : (_validate$data = validate.data) === null || _validate$data === void 0 ? void 0 : _validate$data.tradeId) {
                navigate(paths.baseUrl);
              } else {
                navigate(paths.neighborhoodsUrl);
              }

              setLoading(false);
              _context2.next = 16;
              break;

            case 15:
              setErrorsValidateCode([{
                code: "CODE_REQUIRED",
                field: "code",
                message: "El código es requerido"
              }]);

            case 16:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function handleValidateCode(_x3, _x4, _x5) {
      return _ref2.apply(this, arguments);
    };
  }();

  var handleReSendCode = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(waNumber) {
      var _dataMainTrade$mainTr2, _verify$data11, _verify$data12, _verify$data13, _verify$data14, _verify$dataError, _verify$dataError$err, _verify$dataError2, _verify$dataError2$er, verify, _verify$data15, _verify$data16, _verify$data17, _verify$data18, _verify$data18$user, _verify$data19;

      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              setErrorsValidateCode([]);
              setErrorsVerifyCustomerAccount([]);

              if (!(userWaNumber !== "" && userWaNumber !== undefined)) {
                _context3.next = 13;
                break;
              }

              setLoading(true);
              _context3.next = 6;
              return verifyCustomerAccount(+atob(dataMainTrade === null || dataMainTrade === void 0 ? void 0 : (_dataMainTrade$mainTr2 = dataMainTrade.mainTradeData) === null || _dataMainTrade$mainTr2 === void 0 ? void 0 : _dataMainTrade$mainTr2.id).split(":")[1], userWaNumber);

            case 6:
              verify = _context3.sent;

              if ((verify === null || verify === void 0 ? void 0 : (_verify$data11 = verify.data) === null || _verify$data11 === void 0 ? void 0 : _verify$data11.userWaNumber) && (verify === null || verify === void 0 ? void 0 : (_verify$data12 = verify.data) === null || _verify$data12 === void 0 ? void 0 : _verify$data12.userWaNumber) !== null && (verify === null || verify === void 0 ? void 0 : (_verify$data13 = verify.data) === null || _verify$data13 === void 0 ? void 0 : _verify$data13.userWaNumber) !== undefined && (verify === null || verify === void 0 ? void 0 : (_verify$data14 = verify.data) === null || _verify$data14 === void 0 ? void 0 : _verify$data14.userWaNumber) !== "") {
                setUserData({
                  accessCodeSeconds: verify === null || verify === void 0 ? void 0 : (_verify$data15 = verify.data) === null || _verify$data15 === void 0 ? void 0 : _verify$data15.accessCodeSeconds,
                  siteSettings: verify === null || verify === void 0 ? void 0 : (_verify$data16 = verify.data) === null || _verify$data16 === void 0 ? void 0 : _verify$data16.siteSettings,
                  userWaNumber: verify === null || verify === void 0 ? void 0 : (_verify$data17 = verify.data) === null || _verify$data17 === void 0 ? void 0 : _verify$data17.userWaNumber,
                  userHasAcceptedTyc: !!((verify === null || verify === void 0 ? void 0 : (_verify$data18 = verify.data) === null || _verify$data18 === void 0 ? void 0 : (_verify$data18$user = _verify$data18.user) === null || _verify$data18$user === void 0 ? void 0 : _verify$data18$user.hasAcceptedTyc) || (verify === null || verify === void 0 ? void 0 : (_verify$data19 = verify.data) === null || _verify$data19 === void 0 ? void 0 : _verify$data19.user))
                });
                setShowValidateCode(true);

                if (errorsVerifyCustomerAccount.length > 0) {
                  setErrorsVerifyCustomerAccount([]);
                }
              } else if ((verify === null || verify === void 0 ? void 0 : (_verify$dataError = verify.dataError) === null || _verify$dataError === void 0 ? void 0 : (_verify$dataError$err = _verify$dataError.error) === null || _verify$dataError$err === void 0 ? void 0 : _verify$dataError$err.length) > 0) {
                setErrorsValidateCode(verify === null || verify === void 0 ? void 0 : verify.dataError.error);
              }

              setResendCode(function (resendCodePrev) {
                return !resendCodePrev;
              });
              setCodeState("");
              setSeeCode(false);

              if ((verify === null || verify === void 0 ? void 0 : (_verify$dataError2 = verify.dataError) === null || _verify$dataError2 === void 0 ? void 0 : (_verify$dataError2$er = _verify$dataError2.error) === null || _verify$dataError2$er === void 0 ? void 0 : _verify$dataError2$er.length) === 0) {
                setErrorsValidateCode([{
                  code: "SEND_NEW_CODE_WA",
                  field: "code",
                  message: "Te hemos enviado un nuevo código, porfavor revisa tu WhatsApp"
                }]);
              }

              setLoading(false);

            case 13:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function handleReSendCode(_x6) {
      return _ref3.apply(this, arguments);
    };
  }();

  React.useEffect(function () {
    if (!loadingMainTradeData && (dataMainTrade === null || dataMainTrade === void 0 ? void 0 : dataMainTrade.mainTradeData) === null) {
      setShowWrongTrade(true);
    }

    if (!loadingMainTradeData && (dataMainTrade === null || dataMainTrade === void 0 ? void 0 : dataMainTrade.mainTradeData) && (dataMainTrade === null || dataMainTrade === void 0 ? void 0 : dataMainTrade.mainTradeData) !== null) {
      setShowAnonymousChoice(true);
      localStorage.setItem("mainTrade", JSON.stringify(dataMainTrade));
    }

    if (!loadingMainTradeData && loading) {
      setLoading(false);
    }

    return function () {};
  }, [loadingMainTradeData, dataMainTrade === null || dataMainTrade === void 0 ? void 0 : dataMainTrade.mainTradeData]);
  React.useEffect(function () {
    if (!showValidateCode && errorsValidateCode.length > 0) {
      setErrorsValidateCode([]);
    }

    return function () {};
  }, [showValidateCode]);
  React.useEffect(function () {
    if (user === null || user === void 0 ? void 0 : user.currentTrade) {
      var _user$currentTrade;

      setDefaultCountryCode(user === null || user === void 0 ? void 0 : (_user$currentTrade = user.currentTrade) === null || _user$currentTrade === void 0 ? void 0 : _user$currentTrade.countryCodeMainTrade);
    } else {
      var _dataMainTrade$mainTr3;

      setDefaultCountryCode(dataMainTrade === null || dataMainTrade === void 0 ? void 0 : (_dataMainTrade$mainTr3 = dataMainTrade.mainTradeData) === null || _dataMainTrade$mainTr3 === void 0 ? void 0 : _dataMainTrade$mainTr3.countryCode);
    }

    return function () {};
  }, [user === null || user === void 0 ? void 0 : user.id, dataMainTrade === null || dataMainTrade === void 0 ? void 0 : dataMainTrade.mainTradeData]);
  React.useEffect(function () {
    if (userWaNumber !== "" && errorsVerifyCustomerAccount.length > 0) {
      setErrorsVerifyCustomerAccount([]);
    }

    return function () {};
  }, [userWaNumber]);
  React.useEffect(function () {
    if (codeState !== "" && errorsValidateCode.length > 0) {
      setErrorsValidateCode([]);
    }

    return function () {};
  }, [codeState]);
  React.useEffect(function () {
    if (slug !== slugState) {
      setSlugState(slug);
    }

    return function () {};
  }, [slug]);
  return React.createElement(GoogleReCaptchaProvider, {
    reCaptchaKey: GOOGLE_RECAPTCHA_KEY
  }, loadingMainTradeData || !loadingMainTradeData && dataMainTrade === null ? React.createElement(EcommerceLoginLoading, {
    loading: loadingMainTradeData,
    messageError: intl.formatMessage(logInMessages.canNotEnterTheStore)
  }) : React.createElement(React.Fragment, null, React.createElement(LayoutLoginManager, {
    showValidateCode: showValidateCode,
    disabledAccessButton: showAnonymousChoice,
    defaultCountryCode: defaultCountryCode,
    userWaNumber: userWaNumber,
    setUserWaNumber: setUserWaNumber,
    errorsVerifyCustomerAccount: errorsVerifyCustomerAccount,
    seeCode: seeCode,
    errorsValidateTradeCode: errorsValidateCode,
    code: codeState,
    loading: loading,
    showWrongTrade: showWrongTrade,
    validateTradeCodeDataLoading: false,
    verifyTradeStaffAccountDataLoading: false,
    handleChange: handleChange,
    handleCodeInput: function handleCodeInput(codeValue) {
      return setCodeState(codeValue);
    },
    handleSeeCode: function handleSeeCode() {
      return setSeeCode(!seeCode);
    },
    handleValidateCode: handleValidateCode,
    handleReSendCode: handleReSendCode,
    handleLogIn: handleLogIn,
    tradeName: dataMainTrade === null || dataMainTrade === void 0 ? void 0 : (_dataMainTrade$mainTr4 = dataMainTrade.mainTradeData) === null || _dataMainTrade$mainTr4 === void 0 ? void 0 : _dataMainTrade$mainTr4.name,
    tradeLogo: {
      __typename: "Image",
      alt: (dataMainTrade === null || dataMainTrade === void 0 ? void 0 : (_dataMainTrade$mainTr5 = dataMainTrade.mainTradeData) === null || _dataMainTrade$mainTr5 === void 0 ? void 0 : (_dataMainTrade$mainTr6 = _dataMainTrade$mainTr5.logoImage) === null || _dataMainTrade$mainTr6 === void 0 ? void 0 : _dataMainTrade$mainTr6.alt) || "Easy Pedido",
      url: (dataMainTrade === null || dataMainTrade === void 0 ? void 0 : (_dataMainTrade$mainTr7 = dataMainTrade.mainTradeData) === null || _dataMainTrade$mainTr7 === void 0 ? void 0 : (_dataMainTrade$mainTr8 = _dataMainTrade$mainTr7.logoImage) === null || _dataMainTrade$mainTr8 === void 0 ? void 0 : _dataMainTrade$mainTr8.url) || principleLogo
    },
    userHasAcceptedTyc: userData === null || userData === void 0 ? void 0 : userData.userHasAcceptedTyc,
    siteSettings: userData === null || userData === void 0 ? void 0 : userData.siteSettings,
    accessCodeSeconds: userData === null || userData === void 0 ? void 0 : userData.accessCodeSeconds,
    resendCode: resendCode,
    isDeliveryman: false
  }), showAnonymousChoice && React.createElement(AlertAnonymousChoice, {
    hideModal: function hideModal() {
      return setShowAnonymousChoice(false);
    },
    submit: function submit() {
      navigate(paths.neighborhoodsUrl);
      setShowAnonymousChoice(false);
    },
    tradeName: dataMainTrade === null || dataMainTrade === void 0 ? void 0 : (_dataMainTrade$mainTr9 = dataMainTrade.mainTradeData) === null || _dataMainTrade$mainTr9 === void 0 ? void 0 : _dataMainTrade$mainTr9.name,
    tradeLogo: {
      __typename: "Image",
      alt: (dataMainTrade === null || dataMainTrade === void 0 ? void 0 : (_dataMainTrade$mainTr10 = dataMainTrade.mainTradeData) === null || _dataMainTrade$mainTr10 === void 0 ? void 0 : (_dataMainTrade$mainTr11 = _dataMainTrade$mainTr10.logoImage) === null || _dataMainTrade$mainTr11 === void 0 ? void 0 : _dataMainTrade$mainTr11.alt) || "Easy Pedido",
      url: (dataMainTrade === null || dataMainTrade === void 0 ? void 0 : (_dataMainTrade$mainTr12 = dataMainTrade.mainTradeData) === null || _dataMainTrade$mainTr12 === void 0 ? void 0 : (_dataMainTrade$mainTr13 = _dataMainTrade$mainTr12.logoImage) === null || _dataMainTrade$mainTr13 === void 0 ? void 0 : _dataMainTrade$mainTr13.url) || principleLogo
    }
  })));
};